import {
  APIFieldType,
  ArdoqId,
  getEntityType,
  GroupType,
} from '@ardoq/api-types';
import { sum } from 'lodash';
import { RawGraphNode2 } from '../types';
import { componentGroupTypes } from './consts';
import { DiffType } from '@ardoq/data-model';
import { GraphItem } from './GraphItem';
import { GraphInterface } from '../graphInterface/graphInterface';
import { componentInterface } from '@ardoq/component-interface';
import { fieldInterface } from '@ardoq/field-interface';
import { componentOperations } from '@ardoq/core';

const GROUP_COMPONENT_CLASSNAME = 'fieldGraphNode';
const GROUP_WORKSPACE_CLASSNAME = 'genericGroup';
export const getWorkspaceGroupCss = (cssClassNames: string): string =>
  `${GROUP_WORKSPACE_CLASSNAME} ${cssClassNames}`;

export const getGroupTypeCss = (groupType: GroupType): string => {
  switch (groupType) {
    case GroupType.FIELD:
    case GroupType.COMPONENT:
      return GROUP_COMPONENT_CLASSNAME;
    case GroupType.TAG:
      return 'tagGraphNode';
    case GroupType.ALL:
      return 'allGraphNode';
    default:
      return '';
  }
};

export const countDescendantComponents = (children: RawGraphNode2[]): number =>
  children.filter(({ type }) => !type || componentGroupTypes.has(type)).length +
  sum(children.map(child => countDescendantComponents(child.children ?? [])));

const addedRemovedOrPlaceholder = new Set([
  DiffType.ADDED,
  DiffType.REMOVED,
  DiffType.PLACEHOLDER,
]);
export const getParentChildEdgeDiffType = (
  sourceVisualDiffType: DiffType,
  targetVisualDiffType: DiffType,
  hasParentChanged: boolean
) => {
  if (addedRemovedOrPlaceholder.has(sourceVisualDiffType)) {
    return sourceVisualDiffType;
  }
  if (addedRemovedOrPlaceholder.has(targetVisualDiffType)) {
    return targetVisualDiffType;
  }
  if (targetVisualDiffType === DiffType.CHANGED) {
    if (hasParentChanged) {
      return targetVisualDiffType;
    }
  }
  if (
    sourceVisualDiffType === DiffType.UNCHANGED &&
    targetVisualDiffType === DiffType.UNCHANGED
  ) {
    return DiffType.UNCHANGED;
  }
  return DiffType.NONE;
};
export const getGraphNodes = (
  sourceId: string,
  targetId: string,
  graphNodeMap: Map<string, GraphItem>
) => {
  // TODO do we need new ids for the graph items?
  const sourceGraphNode = graphNodeMap.get(sourceId);
  const targetGraphNode = graphNodeMap.get(targetId);
  if (!sourceGraphNode || !targetGraphNode) {
    throw new Error(
      'Trying to create an edge without according source and/or target nodes'
    );
  }
  return {
    sourceGraphNode,
    targetGraphNode,
  };
};

export const getWorkspaceCssClassNames = (
  grphInterface: GraphInterface,
  workspaceId: ArdoqId
) => {
  const workspace = grphInterface.getWorkspaceById(workspaceId);
  if (!workspace) {
    return '';
  }
  return `${getEntityType(workspace)} id_${workspace._id}`;
};

export const componentHasURLFields = (componentId: ArdoqId): boolean => {
  const component = componentInterface.get(componentId);
  if (!component) return false;
  const urlFields = fieldInterface
    .getFieldsByComponentType(component.typeId, component.model)
    .filter(field => field.type === APIFieldType.URL);
  return componentOperations.hasURLFields(component, urlFields);
};
